// extracted by mini-css-extract-plugin
export default {"conteudo":"HomePage_conteudo__CpUBy","gridConteudo":"HomePage_gridConteudo__PuP7O","container":"HomePage_container__6+ptw","section":"HomePage_section__z3YHV"};